import { procedureIdSchema } from "@assetwatch/procedure-contract";
import { toast } from "@assetwatch/ui";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { saveDefaultProcedure } from "../clients/procedureDefaultClient";
import { useWorkScope } from "../components/WorkScopeProvider";

export function useSetDefaultProcedureMutation() {
  const { selectedCustomer, selectedFacility } = useWorkScope();
  const queryClient = useQueryClient();
  return useMutation({
    onMutate: () => ({
      customerId: selectedCustomer?.id,
      facilityId: selectedFacility?.id,
    }),
    mutationFn: async (procedureId: string | null) => {
      if (!selectedCustomer || !selectedFacility)
        throw new Error("A customer and facility must be selected.");
      return saveDefaultProcedure({
        param: {
          customerId: selectedCustomer.id,
          facilityId: selectedFacility.id,
        },
        json: {
          procedureId:
            procedureId === null ? null : procedureIdSchema.parse(procedureId),
        },
      });
    },
    onSuccess: async (_result, procedureId, scope) => {
      toast.add(
        procedureId
          ? "Default Procedure updated."
          : "Default Procedure cleared.",
        { icon: true },
      );
      await queryClient.invalidateQueries({
        queryKey: ["procedures", scope.customerId, scope.facilityId],
      });
    },
    onError: () =>
      toast.error("Unable to update the default Procedure. Try again.", {
        icon: true,
      }),
  });
}
